(() => {
  const ready = (callback) => {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      callback();
      return;
    }
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  };

  const runOnFirstInteraction = (callback) => {
    let fired = false;
    const fire = () => {
      if (fired) return;
      fired = true;
      cleanup();
      callback();
    };
    const events = ['touchstart', 'scroll', 'mousemove', 'keydown', 'click'];
    const cleanup = () => {
      events.forEach((eventName) => {
        window.removeEventListener(eventName, fire, { passive: true });
      });
    };
    events.forEach((eventName) => {
      window.addEventListener(eventName, fire, { passive: true, once: true });
    });
  };

  const loadDeferredScripts = () => {
    document.querySelectorAll('script[data-defer-src]').forEach((placeholder) => {
      const src = placeholder.getAttribute('data-defer-src');
      if (!src) return;
      const script = document.createElement('script');
      Array.from(placeholder.attributes).forEach((attr) => {
        if (attr.name === 'data-defer-src') return;
        if (attr.name === 'type') return;
        if (attr.name === 'src') return;
        script.setAttribute(attr.name, attr.value);
      });
      script.src = src;
      placeholder.replaceWith(script);
    });

    document.querySelectorAll('iframe[data-defer-src]').forEach((frame) => {
      const src = frame.getAttribute('data-defer-src');
      if (!src) return;
      frame.setAttribute('loading', 'lazy');
      frame.setAttribute('src', src);
      frame.removeAttribute('data-defer-src');
    });
  };

  ready(() => {
    runOnFirstInteraction(loadDeferredScripts);
  });
})();
